import { useEffect, useState } from "react";
import { History, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, euro, formatApiError, formatData, formatMese } from "@/lib/api";

export const PaymentsDialog = ({ tenant, onChange }) => {
  const [open, setOpen] = useState(false);
  const [payments, setPayments] = useState([]);
  const [form, setForm] = useState({ mese: "", data_pagamento: "" });

  const load = async () => {
    const { data } = await api.get(`/tenants/${tenant.id}/payments`);
    setPayments(data);
  };

  useEffect(() => { if (open) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/tenants/${tenant.id}/payments`, form);
      toast.success("Pagamento registrato");
      setForm({ mese: "", data_pagamento: "" });
      await load();
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const remove = async (id) => {
    await api.delete(`/tenants/${tenant.id}/payments/${id}`);
    await load();
    onChange();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><button data-testid={`button-payments-${tenant.id}`} className="btn-ghost px-3 py-1.5 text-xs"><History className="h-3.5 w-3.5" />Storico</button></DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Storico pagamenti — {tenant.nome} {tenant.cognome}</DialogTitle></DialogHeader>
        <form onSubmit={add} className="grid gap-3 rounded-xl bg-slate-50 p-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
          <div><label className="field-label">Mese</label><input data-testid="input-payment-mese" required type="month" className="field-input" value={form.mese} onChange={(e) => setForm({ ...form, mese: e.target.value })} /></div>
          <div><label className="field-label">Pagato il</label><input data-testid="input-payment-data" required type="date" className="field-input" value={form.data_pagamento} onChange={(e) => setForm({ ...form, data_pagamento: e.target.value })} /></div>
          <button data-testid="button-add-payment" type="submit" className="btn-accent py-2.5">Registra</button>
        </form>
        <ul className="max-h-72 space-y-2 overflow-y-auto">
          {payments.length === 0 && <li className="py-6 text-center text-sm text-slate-500">Nessun pagamento registrato.</li>}
          {payments.map((p) => (
            <li key={p.id} data-testid={`payment-item-${p.mese}`} className="flex items-center justify-between rounded-xl border border-slate-200 px-4 py-3 text-sm">
              <div><p className="font-semibold capitalize text-[#0f172a]">{formatMese(p.mese)}</p><p className="text-xs text-slate-500">Pagato il {formatData(p.data_pagamento)} · {euro(p.importo)}</p></div>
              <div className="flex items-center gap-3">
                <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${p.puntuale ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{p.puntuale ? "Puntuale" : "In ritardo"}</span>
                <button data-testid={`button-delete-payment-${p.id}`} onClick={() => remove(p.id)} className="text-slate-400 hover:text-[#dc2626]"><Trash2 className="h-4 w-4" /></button>
              </div>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
